module.exports = __webpack_public_path__ + "img/home-bg.b5018420.png";